import { useEffect, useRef, useState } from 'react';
import { loadGoogleIdentityScript, initGoogleSignIn } from './googleSignIn';

// SHOP-209: rendered by App.js, over everything else, once any backend call
// reports demo_mode_restricted (SHOP-207/208). Embeds the existing Google
// Sign-In flow directly - via an explicit button rather than One Tap, since
// this screen must also handle a visitor already signed in with a
// different, non-allowlisted Google account (index.js's bootstrap only
// triggers One Tap for visitors who aren't a Google user yet).
//
// A successful sign-in reloads the page instead of trying to resume
// whatever was in flight - the ~15+ call sites in productscategories.js
// that hit this state would each need their own retry handling otherwise,
// and a reload re-runs the same bootstrap/data-fetch path as a fresh visit.
export default function PrivateModeScreen() {
  const buttonContainerRef = useRef(null);
  const [scriptLoadFailed, setScriptLoadFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    loadGoogleIdentityScript()
      .then(() => {
        if (cancelled || !buttonContainerRef.current) return;
        initGoogleSignIn({
          buttonContainer: buttonContainerRef.current,
          onSuccess: () => window.location.reload(),
        });
      })
      .catch(() => {
        if (!cancelled) setScriptLoadFailed(true);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      role="dialog"
      aria-label="Modo privado"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F1F3F5',
        padding: '20px',
      }}
    >
      <div
        style={{
          maxWidth: '360px',
          width: '100%',
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          padding: '32px 24px',
          textAlign: 'center',
        }}
      >
        <h2 style={{ margin: '0 0 12px', color: '#0A2540' }}>Modo privado</h2>
        <p style={{ margin: '0 0 24px', color: '#475569', fontSize: '0.95em' }}>
          Esta app está en modo privado. Inicia sesión con una cuenta autorizada para continuar.
        </p>

        <div
          ref={buttonContainerRef}
          style={{ display: 'flex', justifyContent: 'center' }}
        />

        {scriptLoadFailed && (
          <p style={{ marginTop: '16px', color: '#dc2626', fontSize: '0.85em' }}>
            No se pudo cargar el inicio de sesión de Google. Intenta recargar la página.
          </p>
        )}
      </div>
    </div>
  );
}
